'use strict';

module.exports = document.createElement('div').style;



//////////////////
// WEBPACK FOOTER
// ./~/domkit/builtinStyle.js
// module id = 597
// module chunks = 0